import { useMutation } from '@tanstack/vue-query'
import { AxiosError } from 'axios'
import {
  TDefaultError,
  TLoginForm,
  TDefaultOptions,
  TRecoverForm,
  TResetPasswordForm,
  TUser,
} from '@/core/types'
import api from '@/core/config/axios'
import { ensureSanctumCsrfCookie } from '@/core/config/axios/sanctum'

export const useLogin = (options: TDefaultOptions<TUser, TLoginForm>) =>
  useMutation<TUser, AxiosError<TDefaultError>, TLoginForm>({
    mutationFn: async (payload: TLoginForm) => {
      await ensureSanctumCsrfCookie()
      const { data } = await api.post<TUser>('/v1/auth/login', payload)
      return data
    },
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useLogout = (options: TDefaultOptions<any, void>) =>
  useMutation<any, AxiosError<TDefaultError>, void>({
    mutationFn: () =>
      api.post<any>('/v1/auth/logout', {}).then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useRequestPasswordChange = (
  options: TDefaultOptions<any, TRecoverForm>,
) =>
  useMutation<any, AxiosError<TDefaultError>, TRecoverForm>({
    mutationFn: (payload: TRecoverForm) =>
      api
        .post<any>('/v1/auth/password-change/request', payload)
        .then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useResetPassword = (
  options: TDefaultOptions<any, TResetPasswordForm>,
) =>
  useMutation<any, AxiosError<TDefaultError>, TResetPasswordForm>({
    mutationFn: (payload: TResetPasswordForm) =>
      api
        .post<any>('/v1/auth/password-change/reset', payload)
        .then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })
